import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
var bvScript;
var BVLoader = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BVLoader, _React$Component);
  function BVLoader() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var bvId = 'bvLoader';
      if (!bvScript) {
        var script = document.createElement('script');
        script.src = "https://apps.bazaarvoice.com/deployments/" + _this.props.clientName + "/" + _this.props.siteID + "/" + _this.props.env + "/en_US/bv.js";
        document.head.appendChild(script);
        bvScript = true;
      }
    });
    return _this;
  }
  var _proto = BVLoader.prototype;
  _proto.render = function render() {
    return null;
  };
  return BVLoader;
}(React.Component);
export { BVLoader as default };
BVLoader.propTypes = {
  /** Client name for the BazaarVoice account. */
  clientName: PropTypes.string.isRequired,
  /** BazaarVoice site ID. */
  siteID: PropTypes.string.isRequired,
  /** Environment to use (ie. staging or production). */
  env: PropTypes.string.isRequired
};
BVLoader.defaultProps = {
  clientName: 'hillshire-snacking',
  siteID: 'main_site',
  env: 'staging'
};